<template>
  <div>
    <!-- start::signin modal -->
    <signinModal
      @massActionSigninHandler="massActionSigninHandler"
    ></signinModal>
    <!-- end::signin modal -->

    <!-- start::loader -->
    <b-modal
      id="pageLoader"
      hide-footer
      hide-header
      size="sm"
      no-close-on-esc
      title="Page loader"
    >
      <PageLoader />
    </b-modal>
    <!-- end::loader -->
  </div>
</template>

<script>
import signinModal from "./signinModal.vue";
import PageLoader from "./PageLoader.vue";
import { mapActions } from "vuex";
import integtationService from "@/services/integration";
import dailyLogbookService from "@/services/dailyLogbook";

export default {
  props: {
    selectedUsers: {
      type: Array,
      default: () => [],
    },
    parentGrid: {
      type: String,
      default: "dashboard",
    },
  },
  components: {
    signinModal,
    PageLoader,
  },
  methods: {
    ...mapActions("dailyLogbook", ["fetchMultipleUsersData"]),
    ...mapActions("modal", ["setData"]),
    /**
     *
     * @param {area_id:string}
     */
    async massActionSigninHandler({ area_id, site_id, site_name }) {
      let updatedSelectedUsers = [];

      if (this.parentGrid == "userlist")
        updatedSelectedUsers = this.selectedUsers.map((user) => {
          return {
            id: user.current_entity.user_id,
            user_type_id: user.current_entity.user_type_id,
          };
        });
      else if (this.parentGrid == "dashboard") {
        updatedSelectedUsers = JSON.parse(JSON.stringify(this.selectedUsers));
        updatedSelectedUsers = updatedSelectedUsers.map((user) => {
          //Assign expected user type id if expected visit is same day and same site (different/same area)
          const isUserExpectedOnSelectedAreaOrSite =
            user.expectedAreaId &&
            (user.expectedAreaId == area_id || user.expectedSiteId == site_id);
          //Assign old user type (used for signing in) if user already was signed in
          const isUserSignedOutOnSelectedArea =
            user.signedOutAreaId && user.signedOutAreaId == area_id;
          return {
            user_type_id: isUserExpectedOnSelectedAreaOrSite
              ? user.expectedUserTypeId
              : isUserSignedOutOnSelectedArea
              ? user.signedOutUserTypeId
              : user.user_type_id,
            id: user.id,
            visit_id: user.visit_id,
          };
        });
      }

      const wondeIntegrations = await integtationService.getWondeIntegrations();
      const integration_ids = wondeIntegrations?.map(
        (integration) => integration.id
      );

      //check if all selected users are of the same user type
      // const noOfUserTypes = new Set(
      //   updatedSelectedUsers.map((user) => user.user_type_id)
      // )?.size;

      const payload = {
        area_id: area_id,
        integration_ids,
        // user_type_id:
        //   noOfUserTypes > 1 ? "" : this.selectedUsers[0].user_type_id,
        users: updatedSelectedUsers,
      };
      try {
        const signInUsers = await dailyLogbookService.massActionSignInErrors(
          payload
        );
        const { permittedUsers, notPermittedUsers } = signInUsers.data;
        const hasPermittedUsers = Object.values(permittedUsers)?.length;
        const hasUnpermittedUsers =
          notPermittedUsers &&
          Object.keys(notPermittedUsers) &&
          Object.keys(notPermittedUsers).length > 0;

        const hasMoreThanOneErrType =
          notPermittedUsers &&
          Object.keys(notPermittedUsers) &&
          Object.keys(notPermittedUsers).length > 1;

        this.$bvModal.hide("pageLoader");
        this.$bvModal.hide("signinMassaction");

        let firstModalFlag = true;
        let modalData = {};

        Object.assign(payload, { users: permittedUsers });

        if (hasPermittedUsers) {
          /**Permitted + Unpermitted**/
          if (hasUnpermittedUsers) {
            for (const err_type in notPermittedUsers) {
              //Always allow first modal to have "continue + cancel" button
              let modalInfo = {
                site_name,
                err_type,
                acl_errs: notPermittedUsers[err_type],
                displaySingleButton: firstModalFlag ? false : true,
                btnValue: null,
                apiPayload: { payload, site_id },
              };

              Object.assign(modalData, { [err_type]: modalInfo });
              this.setData(modalData);

              switch (err_type) {
                case "host":
                  this.$bvModal.show("someHost");
                  break;

                case "expected":
                  this.$bvModal.show("someExpected");
                  break;

                case "expected_not_today":
                  this.$bvModal.show("someExpectedNotToday");
                  break;

                case "attendance_mode":
                  this.$bvModal.show("someAttendanceMode");
                  break;

                case "user_type":
                  this.$bvModal.show("someUserType");
                  break;
              }
              firstModalFlag = false;
            }
          } else {
            /**Permitted only**/

            await this.fetchMultipleUsersData({ payload, site_id });
            this.$router.history.current.name != "multiplesignin" &&
              this.$router.push({
                name: "multiplesignin",
                params: { multipleSignin: true },
              });
          }
        } else {
          /**Unpermitted only**/
          //more than one error type
          if (hasMoreThanOneErrType) {
            for (const err_type in notPermittedUsers) {
              let modalInfo = {
                site_name,
                err_type,
                acl_errs: notPermittedUsers[err_type],
                displaySingleButton: true,
                btnValue: firstModalFlag ? "Okay" : null,
                apiPayload: null,
              };

              Object.assign(modalData, { [err_type]: modalInfo });
              this.setData(modalData);

              switch (err_type) {
                case "host":
                  this.$bvModal.show("someHost");
                  break;

                case "expected":
                  this.$bvModal.show("someExpected");
                  break;

                case "expected_not_today":
                  this.$bvModal.show("someExpectedNotToday");
                  break;

                case "attendance_mode":
                  this.$bvModal.show("someAttendanceMode");
                  break;

                case "user_type":
                  this.$bvModal.show("someUserType");
                  break;
              }
              firstModalFlag = false;
            }
          }
          //one error type
          else {
            for (const err_type in notPermittedUsers) {
              this.setData({ site_name, err_type });
              switch (err_type) {
                case "host":
                  this.$bvModal.show("allHost");
                  break;

                case "expected":
                  this.$bvModal.show("allExpected");
                  break;

                case "expected_not_today":
                  this.$bvModal.show("allExpectedNotToday");
                  break;

                case "attendance_mode":
                  this.$bvModal.show("allAttendanceMode");
                  break;

                case "user_type":
                  this.$bvModal.show("allUserType");
                  break;
              }
            }
          }
        }
      } catch (e) {
        this.$bvModal.hide("pageLoader");
      }
    },
  },
};
</script>

<style>
#pageLoader___BV_modal_body_ {
  padding: 0 !important;
  height: 0 !important;
  border: 0 !important;
}
#pageLoader___BV_modal_content_ {
  width: 0 !important;
  border: 0 !important;
}
.close-btn {
    position: absolute;
    top: 32px;
    inset-inline-end: 32px;
    direction: ltr;
  }
</style>
